<template>
  <div class="flow-container">
    <div class="title">流量详情</div>
    <el-card style="margin-top:10px">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="流量详情"
                     name="flow">
          <flow-detail></flow-detail>
        </el-tab-pane>
        <el-tab-pane label="超限查询"
                     name="overrun">
          <over-run-query />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>

import OverRunQuery from './OverRunQuery';
import FlowDetail from './FlowDetail';

export default {
  components: { OverRunQuery, FlowDetail },
  data() {
    return {
      activeName: null
    };
  },
  props: ['active'],
  methods: {
    handleClick(tab, event) {

    }
  },
  async created() {
    this.activeName = this.active;
  }
};
</script>

<style lang="less" scoped>
.title {
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: rgba(0, 0, 0, 1);
  font-weight: 500;
  line-height: 32px;
}
</style>
